// extracted by mini-css-extract-plugin
export default {"root":"CollapsibleTrigger_root__zdJVe","title":"CollapsibleTrigger_title__8Dm+o","actions":"CollapsibleTrigger_actions__1jn3Z","expanded":"CollapsibleTrigger_expanded__xJBsl"};